module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.itemForm,
      "items": _vm.itemForm
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitAddForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Sharing Cluster")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10011830"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-add-share.vue
// module id = 531
// module chunks = 4 5 6